import type { Router } from 'vue-router';
import useEdition from '@/hooks/useEdition';
import { NOT_FOUND } from '../constants';

export default function setupEditionGuard(router: Router) {
  router.beforeEach((to, from, next) => {
    const { isRouteDisabled } = useEdition();
    if (to.name && isRouteDisabled(to.name)) {
      next(NOT_FOUND);
      return;
    }
    next();
  });
}
